<section class="staff-warehouse-cell-grid">
  <div class="staff-warehouse-cell-grid__header">
    <h2 class="staff-warehouse-cell-grid__title">
      {{ 'admin.warehouses.cells.title' | translate }}
    </h2>
    <div class="staff-warehouse-cell-grid__toolbar">
      <button
        type="button"
        class="staff-warehouse-cell-grid__mode-btn"
        [class.staff-warehouse-cell-grid__mode-btn--active]="selectionMode()"
        (click)="onToggleSelectionMode()"
      >
        {{
          (selectionMode()
            ? 'admin.warehouses.cells.cancelSelection'
            : 'admin.warehouses.cells.selectForPrint') | translate
        }}
      </button>
      @if (selectionMode()) {
      <lib-not-button
        [text]="'admin.warehouses.cells.printSelected' | translate"
        [color]="'#0B6270'"
        [bgColor]="'#DCF6F2'"
        [disabled]="!canPrintSelected()"
        [action]="{ type: 'action' }"
        (actionEvent)="onPrintSelected()"
      />
      }
    </div>
  </div>

  <div class="staff-warehouse-cell-grid__legend">
    <span class="staff-warehouse-cell-grid__legend-item">
      <span
        class="staff-warehouse-cell-grid__legend-swatch staff-warehouse-cell-grid__legend-swatch--available"
      ></span>
      {{ 'admin.warehouses.cells.legendAvailable' | translate }}
    </span>
    <span class="staff-warehouse-cell-grid__legend-item">
      <span
        class="staff-warehouse-cell-grid__legend-swatch staff-warehouse-cell-grid__legend-swatch--occupied"
      ></span>
      {{ 'admin.warehouses.cells.legendOccupied' | translate }}
    </span>
    @if (selectionMode() && selectedCount() > 0) {
    <span class="staff-warehouse-cell-grid__selection-count">
      {{
        'admin.warehouses.cells.selectedCount'
          | translate: { count: selectedCount() }
      }}
    </span>
    }
  </div>

  @if (loading()) {
  <p class="staff-warehouse-cell-grid__state">
    {{ 'common.loading' | translate }}
  </p>
  } @else if (error(); as loadError) {
  <p class="staff-warehouse-cell-grid__state staff-warehouse-cell-grid__state--error">
    {{ loadError }}
  </p>
  } @else if (gridRows().length === 0) {
  <p class="staff-warehouse-cell-grid__state staff-warehouse-cell-grid__state--warn">
    {{ 'admin.warehouses.placement.noGridConfig' | translate }}
  </p>
  } @else {
  <div class="staff-warehouse-cell-grid__rows">
    @for (row of gridRows(); track row.rowNumber) {
    <section class="staff-warehouse-cell-grid__row">
      <h3 class="staff-warehouse-cell-grid__row-title">
        {{ 'warehouse.rowsSection.rowLabel' | translate }} {{ row.rowNumber }}
      </h3>
      <div
        class="staff-warehouse-cell-grid__matrix"
        [style.grid-template-columns]="'repeat(' + row.columns + ', minmax(0, 1fr))'"
      >
        @for (slot of row.slots; track slot.label) {
        <button
          type="button"
          class="staff-warehouse-cell-grid__slot"
          [class.staff-warehouse-cell-grid__slot--occupied]="slot.isOccupied"
          [class.staff-warehouse-cell-grid__slot--available]="!slot.isOccupied"
          [class.staff-warehouse-cell-grid__slot--selected]="
            isCellSelected(slot.cell?.id)
          "
          [class.staff-warehouse-cell-grid__slot--missing]="!slot.cell"
          [disabled]="!slot.cell"
          [attr.aria-label]="
            slotAriaLabel(slot.label, slot.isOccupied, slot.cell?.id)
          "
          (click)="onSlotClick(slot.cell)"
        >
          <span class="staff-warehouse-cell-grid__slot-label">{{
            slot.shortLabel
          }}</span>
        </button>
        }
      </div>
    </section>
    }
  </div>
  }
</section>
